export default __webpack_public_path__ + "static/media/Mark-4-HUD-Omega Widget.1b67a1b7.jpg";